import MissingUserData from '@/component/add-user-stake/MissingUserData';
import RegisterForm from '@/component/add-user-stake/RegisterForm';
import Header from '@/component/Header';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';

export default function AddUserStake() {
  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', md: '0px' },
      }}
    >
      {/* 스크롤 기능 */}
      <Box
        sx={{
          padding: '24px',
          maxWidth: '1680px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Card>
            <Header title="사용자 수동 스테이킹 등록" />
            <CardContent>
              <Typography variant="h6">사용자 조회</Typography>
              <MissingUserData />
              <Box mb={10} />
              <Typography variant="h6">스테이킹 등록</Typography>
              <RegisterForm />
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
